import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";
import { Observable, Subject } from "rxjs";
import { map, startWith, switchMap, takeUntil } from "rxjs/operators";
import { ShipmentSku } from "src/app/models/shipyard.model";
import { PlanyardService } from "./../../../modules/planyard/planyard.service";
import { DialogActions } from "../dialog.model";
import { SetSkuMapPayload } from "src/app/models/planyard.model";
import { HeaderService } from "../../header/header.service";

@Component({
  selector: "app-map-sku-to-product",
  templateUrl: "./map-sku-to-product.component.html",
  styleUrls: ["./map-sku-to-product.component.scss"],
})
export class MapSkuToProductComponent implements OnInit,OnDestroy {
  private destroy$ = new Subject<void>();
  fitleredItemsOptions = [];
  currentProduct: any;
  existingSkuProducts: any[] = [];
  shipmentList:any
  toggleActive = new FormControl();
  skuForm: FormGroup = new FormGroup({
    skuAutocomplete: new FormControl("", [Validators.required]),
    skuQty: new FormControl(1, [
      Validators.required,
      Validators.pattern("^[0-9]*$"),
    ]),
  });
  productsForm: FormArray = new FormArray([]);
  filteredOptions$: Observable<any>;
  skuMappingfilteredOptions: any[] = [];
  actions: any[];
  startRow:number = 0;
  amountPerPage:number = 10;
  startRowArray:any[]=[];
  productInfo:any;
  isActiveForm:boolean = false;
  selectedSKU:any[]=[];
  skuMappingForm: FormGroup = new FormGroup({
    skuMappingcomplete: new FormControl(),
    skuQty: new FormControl(1,[Validators.required, Validators.pattern("^[0-9]*$")])
  });
  account:string;
  storedFilterOptions:any[] =[];
  ShipmentSkuList: ShipmentSku[];
  constructor(
    private shipyardService: ShipyardService,
    public dialogRef: MatDialogRef<MapSkuToProductComponent>,
    private dialog: MatDialog,
    private headerService: HeaderService,
    @Inject(MAT_DIALOG_DATA) public data :{
      product:any,
      sku:any,
      isCreateOrder:boolean;
      callBackFn: (dialogRef: MatDialogRef<any>,data:SetSkuMapPayload, actions: DialogActions[],isActive:boolean) => void;
    },
    public planyardService: PlanyardService
  ) {
    this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => (this.account = e[0]));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  ngOnInit(): void {
      if(this.data.product){
        this.loadProduct(this.data.product.ItemId)
      }else if (this.data.sku){
        this.isActiveForm = true;
        this.toggleActive.setValue(true);
        if(this.data.sku.ProductId) this.loadProduct(this.data.sku.ProductId)
      }
    this.filteredOptions$ = this.skuForm
      .get("skuAutocomplete")
      .valueChanges.pipe(
        switchMap((value) => this.shipyardService.typeaheadSkuProduct("", value, '', true,true))
      );
      this.skuMappingForm.get("skuMappingcomplete")
      .valueChanges.pipe(
        startWith(""),
        takeUntil(this.destroy$),
        map((value) => (value ? value : "")),
        switchMap((value) => {
          return this.shipyardService.typeaheadSkuProduct("", value, '', true,true)          
        }),
      )
      .subscribe((e: any) => {
        this.startRow = 0;
        this.storedFilterOptions = e;
        this.skuMappingfilteredOptions = e.slice(this.startRow, this.startRow + this.amountPerPage);
    });
    if (this.data.product) {
      this.currentProduct = this.data.product;
      this.currentProduct.itemName = this.currentProduct.Name;
      this.addProductToForm(1, this.currentProduct, true);
    } else if (this.data.sku) {
      this.data.sku.sku = this.data.sku.Sku;
      this.data.sku.accountSkuId = this.data.sku.AccountSkuId;
      this.skuForm.patchValue({ skuAutocomplete: this.data.sku });
      this.skuMappingForm.patchValue({ skuMappingcomplete: this.data.sku,skuQty:this.data.sku.Qty });
      this.optionSelected(this.data.sku);
      this.onChange(this.data.sku);
    }
    this.actions = [
      { text: 'Cancel', buttonStyle: 'underline' },
      { text: 'Confirm', isDisabled: true}
    ];
    
       
    this.skuForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      if (this.isCurrentFormValid() /*this.skuForm.valid*/) {
        this.actions[1].isDisabled = false;
      } else {
        this.actions[1].isDisabled = true;
      }
    });
    
   this.productsForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      if (this.isCurrentFormValid() ) {
        this.actions[1].isDisabled = false;
      } else {
        this.actions[1].isDisabled = true;
      }
    });

    this.skuMappingForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      if (this.isSkuFormValid() ) {
        this.actions[1].isDisabled = false;
      } else {
        this.actions[1].isDisabled = true;
      }
    });
  }

  isSkuFormValid(){
    return this.selectedSKU?.length > 0;
  }
  
  isCurrentFormValid()
  {
    return this.skuForm?.value?.skuAutocomplete?.accountSkuId && this.productsForm.valid && this.productsForm.value.every(product=> (product?.product?.ItemId || product?.product?.itemId || product?.product?.id) && product?.qty )}

  action(e) {
    if (e === "Confirm") {
      let data
      if(this.isActiveForm){
         data={
          accountSkuId: this.skuForm.value.skuAutocomplete.accountSkuId,
          itemQtys: this.productsForm.value.map((product) => {
            return {
              itemId: product.product.ItemId || product.product.itemId || product.product.id,
              qty: product.qty,
            };
          }),
        }
      }else{
        const accountSkuQty = this.selectedSKU.map((e) => {
          return {
            accountSkuId: e.accountSkuId,
            qty: e.qty
          };
        });
        data={
          itemId: this.data.sku?.ProductId || this.data.product?.ItemId,
          accountSkuQtys: accountSkuQty
        }
      }
     
      if(this.data.callBackFn)
      {
              this.actions[1].spin = true;
              this.data.callBackFn(this.dialogRef,data,this.actions,this.isActiveForm);
      }
      else{ this.dialogRef.close({data:data,isActive:this.isActiveForm});}
    } else {
      this.dialogRef.close();
    }
  }

  displayWith(value: ShipmentSku) {
    if (value) {
      return value.sku;
    }
  }

  optionSelected(event) {
    this.planyardService
      .GetSkuMappings(event.accountSkuId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((e: any[]) => {
        this.removeProductsFromForm();
        this.existingSkuProducts = e;
        e.forEach((product) => {
          if (!this.currentProduct || product.itemId !== this.currentProduct.ItemId) {
            this.addProductToForm(product.qty, product, false);
          }
        });
      });
  }

  addProductToForm(qty, product, productDisabled) {
    this.productsForm.push(this.newProductFormGroup(qty, product, productDisabled));
    this.addItemsAutocomplete(this.fitleredItemsOptions.length);
  }

  removeProductsFromForm() {
    this.existingSkuProducts.forEach(e => {
      const index = this.productsForm.value.findIndex(product => {
        return product.itemId === e.itemId;
      });
      if (index) {
        this.removeProductFromForm(index);
      }
    })
  }

  removeProductFromForm(index) {
    this.productsForm.removeAt(index)
  }

  newProductFormGroup(qty?, Product?, productDisabled = false) {
    return new FormGroup({
      qty: new FormControl(qty, [Validators.min(0),Validators.required,Validators.pattern("^[0-9]*$")]),
      product: new FormControl({...Product, disabled: productDisabled}),
    });
  }

  removeProduct(index) {
    this.productsForm.removeAt(index);
    this.removeItemsAutocomplete(index);
  }

  removeItemsAutocomplete(index: number) {
    this.fitleredItemsOptions.splice(index, 1);
  }

  displayFn(item) {
    return item ? item.itemName || item.name : "";
  }

  addItemsAutocomplete(index: number) {
    this.fitleredItemsOptions.push([]);
    this.productsForm
      .at(index)?.get("product")
      .valueChanges.pipe(
        startWith(""),
        takeUntil(this.destroy$),
        map((value) => (value ? value : "")),
        switchMap((value) => {
          if(value){
            this.startRow=0;
            const idx=Object.keys(this.startRowArray).findIndex(res=>res == 'startrow_'+index)
            if(idx != -1){
              this.startRowArray['startrow_'+index]=0
            }else{
              this.startRowArray['startrow_'+index] = 0;  
            }
            return this.planyardService.TypeaheadItem(value, null, 'Item',this.startRow,this.startRow + this.amountPerPage)
          } else{
            let e = [];
            return e;
          }
        }),
      )
      .subscribe((e: any) => {
        this.fitleredItemsOptions[index] = e;
        this.startRowArray['startrow_'+index]+= this.amountPerPage;
    });
  }

  close() {
    this.dialogRef.close();
  }

  setScroll(index){
    const ele= document.querySelectorAll('[id*="mat-autocomplete-"]');
    if(ele.length){
      const id = document.querySelectorAll('[id*="mat-autocomplete-"]')[0].id;
      const element= document.getElementById(id);
      if(element){     
        this.registerPanelScrollEvent(element,index);
      }
    }
  }

    registerPanelScrollEvent(element,index) {
      const panel = element;
     panel.addEventListener('scroll', event => this.loadAllOnScroll(event,index));
   }

   loadAllOnScroll(event,index) {
    if (event.target.scrollTop + event.target.offsetHeight == event.target.scrollHeight) {     
      const idx=Object.keys(this.startRowArray).findIndex(res=>res == 'startrow_'+index)
      if(idx != -1){
        this.startRow=this.startRowArray['startrow_'+index];
      }else{
        this.startRowArray['startrow_'+index] = 0; 
        this.startRow=0;
      }
      this.startRowArray['startrow_'+index]+= this.amountPerPage;
      const value= this.productsForm.at(index).get("product").value;
      this.planyardService.TypeaheadItem(value, null, 'Item',this.startRow,this.startRow + this.amountPerPage).pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
        this.fitleredItemsOptions[index].push(...res);
      });
    }
  }

  changeToggle(event){
    if(event.checked){
      this.isActiveForm = true;
    }else{
     this.isActiveForm = false;   
    }
  }
  
   loadProduct(productId){
    this.planyardService
    .GetProductDetails(productId).pipe(takeUntil(this.destroy$))
    .subscribe((response: any) => {
       if(response){
        this.productInfo = {
          name: response.title,
          id: response.name,
          image: response.imageUrl,
        }
       }
    });
   }
   verifyAndLoadSku(){
    const index = this.selectedSKU.findIndex((res)=> res.sku == this.shipmentList.sku);
    if(index > -1){
      this.selectedSKU[index].qty = this.shipmentList.qty
    }else{
      this.selectedSKU.push(this.shipmentList);
    }     
     this.skuMappingForm.get("skuQty").setValue(1);
     this.skuMappingForm.get("skuMappingcomplete").setValue('');
   }

   onChange(event){
    event.qty = event.Qty ? event.Qty : this.skuMappingForm.value.skuQty;
    event.title = event.Title ? event.Title : event?.title;
    event.imageUrl = event.ImageUrl ? event?.ImageUrl : event?.imageUrl;
    this.shipmentList = event;
   }

   onPaste($event: ClipboardEvent) {
    const pastedText = $event.clipboardData.getData("text");
    this.shipyardService
      .TypeaheadSku(this.account, pastedText, '', null, true).pipe(takeUntil(this.destroy$))
      .subscribe((skus) => {
        this.ShipmentSkuList = skus as ShipmentSku[];
      });
  }

  removeSku(sku) {
    this.selectedSKU = this.selectedSKU.filter(
      (currentSku) => sku.sku !== currentSku.sku
    );
    this.actions[1].isDisabled = !this.selectedSKU.length
  }

  changeQty($event){
    this.shipmentList.qty = Number($event.target.value);
  }

  setScrollForSku(){
    const ele= document.querySelectorAll('[id*="mat-autocomplete"]');
    if(ele.length){
      const id = document.querySelectorAll('[id*="mat-autocomplete-"]')[0].id;
      const element= document.getElementById(id);
      if(element){     
        this.registerPanelEvent(element);
      }
    }
  }

  registerPanelEvent(element) {
      const panel = element;
     panel.addEventListener('scroll', event => this.loadScroll(event));
   }

   loadScroll(event) {
    if (event.target.scrollTop + event.target.offsetHeight == event.target.scrollHeight) { 
      if (this.startRow + this.amountPerPage < this.storedFilterOptions?.length) {
        this.startRow += this.amountPerPage;
        let filterArray = this.storedFilterOptions.slice(this.startRow, this.startRow + this.amountPerPage)
        this.skuMappingfilteredOptions.push(...filterArray);
      }
    }
  }
}
